import React, {createContext, useContext, useState} from 'react';

const AppContext = createContext();

export const AppProvider = ({children}) => {
    const [hasTopbar, showTopbar] = useState(true);

    return (
        <AppContext.Provider value={{hasTopbar, showTopbar}}>
            {children}
        </AppContext.Provider>
    );
};

export const useAppContext = () => useContext(AppContext);
